import {defineStore} from 'pinia';

import {fetchWrapper} from '@/helpers/fetch-wrapper';
import {showSuccessToast} from "vant";


const baseUrl = `${process.env.VUE_APP_API_URL}/user/files`;

export const useUserFileStore = defineStore({
    id: 'userFile',
    state: () => ({
        files: [],
        userFile: {},
        name: '',
        status: '',
    }),
    actions: {
        async fetchAll() {
            const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
            const response = await fetchWrapper.get(`${baseUrl}/` + '?name=' + this.name + "&status=" + this.status + "&account_id=" + accountId, null);
            this.files = response.data;
        },

        async fetchOne(id) {
            const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
            const response = await fetchWrapper.get(`${baseUrl}/` + id +"?account_id=" + accountId, null);
            this.userFile = response.data;
        },

        async updateResource(id) {
            const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
            const response = await fetchWrapper.put(`${baseUrl}/` + id +"?account_id=" + accountId, {});
            this.userFile = response.data;
            await this.downloadFile(this.userFile.ssr_url, this.userFile.name + '.' + this.userFile.extension);
        },

        async downloadFile(sourceUrl, fileName) {
            const accessToken = JSON.parse(localStorage.getItem('user')).access_token;
            const response = await fetch(sourceUrl, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + accessToken,
                },
            });
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
            showSuccessToast('Downloaded');
        }
    }
});
